import type {TextProps} from '@smart/react-components';
import {
  Markdown,
  Text,
  defaultMarkdownOverrides,
} from '@smart/react-components';
import * as React from 'react';
import {MarkdownLink} from './markdown-link';

export interface LearnMoreTextProps {
  readonly children: string;
  readonly noMargin?: boolean;
}

export function LearnMoreText({children}: LearnMoreTextProps): JSX.Element {
  return (
    <Markdown
      overrides={{
        p: {
          ...defaultMarkdownOverrides.p,
          component: Text,
          props: {
            ...defaultMarkdownOverrides.p.props,
            variant: `p-100`,
          } satisfies TextProps,
        },
        a: {
          component: MarkdownLink,
        },
      }}
    >
      {children}
    </Markdown>
  );
}
